<template>
  <div class="popup_in">
    <div class="popup">
      <div class="ic-ok"><okSvg /></div>
      <div class="title">
        {{ title }} הניתוח הסתיימה בהצלחה. יש לשבץ את הניתוח בבלוק שהוגדר לרופא.
      </div>
      <div v-if="notice" class="confirm-surg-notice">{{ notice }}</div>
      <div class="flex flex--content--center">
        <a class="bt_blue" href="" @click.prevent="goBackRoute">סגור</a>
      </div>
    </div>
  </div>
</template>

<script>
import okSvg from "../../assets/img/svg/ok.svg";
import { getHash } from "../../utilities/hash.js";

export default {
  name: "ConfirmSurg",
  components: {
    okSvg
  },
  props: {
    title: { type: String, required: true },
    notice: { type: String, default: "" }
  },
  methods: {
    goBackRoute() {
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        this.$router.push("/dashboard/surgeries");
      } else {
        const hash = getHash({});
        this.$router.push("/dashboard/surgeries/#" + hash);
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.confirm-surg-notice {
  color: #b00020;
  font-size: 20px;
  margin: 18px auto;
  max-width: 620px;
}
</style>
